import Experience from './Experience/index'

function initGlobe() {
  let experience = null
  experience = new Experience()
}

export default initGlobe
